import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

// Sent vs Opened per email category (PascalCase from the API).
const COLORS = {
  sent: "#0ea5e9",
  opened: "#1a3a5c"
};

const CategoryBreakdownChart = ({ data }) => {
  const rows = (data || []).map(d => ({
    category: d.Category,
    Sent: d.Sent,
    Opened: d.Opened
  }));

  if (!rows.length) {
    return <div className="chart-empty">No categorized email in this range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={rows} margin={{ top: 10, right: 20, bottom: 0, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="category" />
        <YAxis allowDecimals={false} />
        <Tooltip />
        <Legend />
        <Bar dataKey="Sent" fill={COLORS.sent} />
        <Bar dataKey="Opened" fill={COLORS.opened} />
      </BarChart>
    </ResponsiveContainer>
  );
};

CategoryBreakdownChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      Category: PropTypes.string,
      Sent: PropTypes.number,
      Opened: PropTypes.number
    })
  )
};

export default CategoryBreakdownChart;
